import { IRegion } from '@/creditflowresearch/domain/vo/Region';
import Region from './Region';
import UsoaRegion from './entities/UsoaRegion';
import EmeaRegion from './entities/EmeaRegion';
import ApacRegion from './entities/ApacRegion';
import LatmRegion from './entities/LatmRegion';

type RegionConstructor = new (data: IRegion) => Region;

class RegionFactory {
  private static readonly entityClassMap = new Map<string, RegionConstructor>([
    [UsoaRegion.REGION_ID, UsoaRegion],
    [EmeaRegion.REGION_ID, EmeaRegion],
    [ApacRegion.REGION_ID, ApacRegion],
    [LatmRegion.REGION_ID, LatmRegion],
  ]);

  static createFromData(data: IRegion): Region | null {
    const EntityClass = RegionFactory.entityClassMap.get(data.id);

    if (!EntityClass) {
      return null;
    }

    return new EntityClass({
      id: data.id,
      abbreviation: data.abbreviation,
      name: data.name,
      displayName: data.displayName,
      emDisplayName: data.emDisplayName,
      beta: data.beta,
      countryList: data.countryList,
      priority: data.priority,
      shortDisplayName: data.shortDisplayName,
      timeZoneId: data.timeZoneId,
    });
  }
}

export default RegionFactory;
